(function() {
    'use strict';

    angular
        .module('app.inscripciones')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/inscripciones',
                config: {
                    templateUrl: 'app/inscripciones/list.html',
                    controller: 'inscripciones.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/tiempos',
                config: {
                    templateUrl: 'app/inscripciones/list-tiempos.html',
                    controller: 'inscripciones.Tiempos',
                    controllerAs: 'vm',
                    title: 'Tiempos'
                }
            },
            {
                url: '/numeros',
                config: {
                    templateUrl: 'app/inscripciones/list-numeros.html',
                    controller: 'inscripciones.Numeros',
                    controllerAs: 'vm',
                    title: 'Numeros'
                }
            },
            {
                url: '/seleccionar-atleta',
                config: {
                    templateUrl: 'app/inscripciones/list-atletas.html',
                    controller: 'inscripciones.Atletas',
                    controllerAs: 'vm',
                    title: 'Atletas'
                }
            },
            {
                url: '/editar-inscripcion/:id?',
                config: {
                    templateUrl: 'app/inscripciones/edit.html',
                    controller: 'inscripciones.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            },
            {
                url: '/crear-inscripcion/:eventoId',
                config: {
                    templateUrl: 'app/inscripciones/edit.html',
                    controller: 'inscripciones.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            },
            {
                url: '/editar-pago/:id',
                config: {
                    templateUrl: 'app/inscripciones/edit-pago.html',
                    controller: 'inscripciones.EditPago',
                    controllerAs: 'vm',
                    title: 'EditPago'
                }
            },
            {
                url: '/editar-pago-v2/:id',
                config: {
                    templateUrl: 'app/inscripciones/edit-pago-v2.html',
                    controller: 'inscripciones.EditPagoV2',
                    controllerAs: 'vm',
                    title: 'EditPago'
                }
            },
        ];
    }
})();
